import React from 'react'
import { QuestionFrame, YesNoQuestion } from 'components/questions'


export const Q13 = () => {

  return (
    <QuestionFrame q={13}>
      <YesNoQuestion num={1} content={'専有部等、災害時に人が滞留する場所に、手動開閉可能な窓、換気口、又はこれらに類する開口部（排煙窓や非常進入口専用窓等）がありますか。'} />
    </QuestionFrame>
  )
}
